import React, { useEffect } from 'react';
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate,
} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { startChecking } from '../Redux/actions/loginAction';
import { PublicRoute } from './PublicRoute';
import { PrivateRoute } from './PrivateRoute';
import Logo from '../img/logo.png';

// Rutas públicas
import Home from '../Pages/Home/Home';
import Descripcion from '../Pages/Descripcion/Descripcion';
import Contacto from '../Pages/Contacto/Contacto';
import Nosotros from '../Pages/Nosotros/Nosotros';
import NuestrasPropiedades from '../Pages/NuestrasPropiedades/NuestrasPropiedades';
import Blog from '../Pages/Blog/Blog';
import DetalesBlog from '../Pages/DetalesBlog/DetalesBlog';
import RecoverPassword from '../Pages/RecoverPassword/RecoverPassword';
import ResetPassword from '../Pages/RecoverPassword/ResetPassword';
import Login from '../Pages/Login/Login';
import Privacidad from '../Pages/Privacidad/Privacidad';
import Terminos from '../Pages/Privacidad/Terminos';
import Soporte from '../Pages/Soporte/Soporte';

// Rutas privadas
import Dashboard from '../Pages/Dashboard/Dashboard';
import Users from '../Pages/Users/Users';
import Profile from '../Pages/Profile/Profile';
import Settings from '../Pages/Settings/Settings';
import Blogs from '../Pages/Blogs/Blogs';
import Lotes from '../Pages/Lotes/Lotes';
import Propiedades from '../Pages/Propiedades/Propiedades';
import Desarrollos from '../Pages/Desarrollos/Desarrollos';
import Cotizador from '../Pages/Cotizador/Cotizador';
import CotizadorInteractivo from '../Pages/CotizadorInteractivo/CotizadorInteractivo';

const AppRouter = () => {
    const dispatch = useDispatch();
    const { checking, uid, idRol } = useSelector((state) => state.login);

    useEffect(() => {
        dispatch(startChecking());
    }, [dispatch]);

    if (checking) {
        return (
            <div className="content-spinner">
                <div className="cont-img-loading">
                    <img src={Logo} alt="Logo" />
                </div>
                <div className="lds-ripple"><div></div><div></div></div>
            </div>
        );
    }

    return (
        <Router>
            <Routes>
                {/* 🔓 RUTAS PÚBLICAS */}
                <Route element={<PublicRoute isAuthenticated={!!uid} />}>
                    <Route path="/" element={<Home />} />
                    <Route path="/inicio" element={<Home />} />
                    <Route path="/descripcion-propiedad/:id" element={<Descripcion />} />
                    <Route path="/contacto" element={<Contacto />} />
                    <Route path="/nosotros" element={<Nosotros />} />
                    <Route path="/nuestras-propiedades" element={<NuestrasPropiedades />} />
                    <Route path="/nuestras-propiedades/:input" element={<NuestrasPropiedades />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/blog-detalles/:id" element={<DetalesBlog />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/recover-password" element={<RecoverPassword />} />
                    <Route path="/resetpassword/:id" element={<ResetPassword />} />
                    <Route path="/soporte" element={<Soporte />} />
                    <Route path="/privacidad" element={<Privacidad />} />
                    <Route path="/terminos" element={<Terminos />} />
                </Route>

                {/* 🔒 RUTAS PRIVADAS */}
                <Route element={<PrivateRoute isAuthenticated={!!uid} />}>
                    <Route path="/dashboard" element={<Dashboard />} />
                    {["63ddabebcce4e43d749383a7", "63ddac35cce4e43d749383ab"].includes(idRol) && (
                        <>
                            <Route path="/users" element={<Users />} />
                            <Route path="/propiedades" element={<Propiedades />} />
                            <Route path="/lotes" element={<Lotes />} />
                            <Route path="/blogs" element={<Blogs />} />
                        </>
                    )}
                    <Route path="/cotizador" element={<Cotizador />} />
                    <Route path="/cotizador-interactivo/:id" element={<CotizadorInteractivo />} />
                    <Route path="/desarrollos" element={<Desarrollos />} />
                    <Route path="/profile" element={<Profile />} />
                    <Route path="/settings" element={<Settings />} />
                </Route>

                {/* 🧭 CATCH-ALL */}
                <Route path="*" element={<Navigate to={uid ? "/dashboard" : "/"} replace />} />
            </Routes>
        </Router>
    );
};

export default AppRouter;
